(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-hero"] && !Shopify.designMode) return;
  try {
    (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const init=()=>{const nodes=document.querySelectorAll('.aa>*,.ac>*,.ap>*,.aj>*,.ads>header,.ads-chapter,.ak>*,.acl>*');const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('atelier-motion-visible');observer.unobserve(entry.target)}}),{threshold:.1,rootMargin:'0px 0px -7%'});nodes.forEach(node=>{if(node.dataset.atelierMotion)return;node.dataset.atelierMotion='true';node.classList.add('atelier-motion-item');observer.observe(node)})};init();document.addEventListener('shopify:section:load',init)})();
(()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
const TILT='.ap-grid article,.aj-card,.ak-grid article,.ac-grid a>div';
const on=(e)=>{const c=e.currentTarget;const r=c.getBoundingClientRect();
const dx=(e.clientX-r.left)/r.width-.5, dy=(e.clientY-r.top)/r.height-.5;
c.style.transform=`perspective(760px) rotateY(${dx*6}deg) rotateX(${-dy*6}deg) translateY(var(--bh-ty,0))`;};
const off=(e)=>{e.currentTarget.style.transform='';};
const bind=()=>document.querySelectorAll(TILT).forEach(c=>{if(c.dataset.bhTilt)return;
c.dataset.bhTilt='1';c.addEventListener('mouseenter',on);c.addEventListener('mousemove',on);
c.addEventListener('mouseleave',off);});
bind();document.addEventListener('shopify:section:load',bind);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-countdown"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-dc]').forEach((root) => {
    if (root.dataset.dcInit) return;
    root.dataset.dcInit = '1';

    const start = new Date(root.dataset.start).getTime();
    const drop = new Date(root.dataset.drop).getTime();
    const box = {
      d: root.querySelector('[data-dc-d]'), h: root.querySelector('[data-dc-h]'),
      m: root.querySelector('[data-dc-m]'), s: root.querySelector('[data-dc-s]'),
    };
    const fill = root.querySelector('[data-dc-fill]');
    const pad = (n) => String(n).padStart(2, '0');

    let timer = null;
    const tick = () => {
      const now = Date.now();
      let left = drop - now;
      if (left <= 0) {
        left = 0;
        if (timer) { clearInterval(timer); timer = null; }
        if (fill) fill.style.width = '100%';
      } else if (fill && drop > start) {
        const pct = Math.max(0, Math.min(100, ((now - start) / (drop - start)) * 100));
        fill.style.width = pct.toFixed(2) + '%';
      }
      box.d.textContent = pad(Math.floor(left / 86400000));
      box.h.textContent = pad(Math.floor(left / 3600000) % 24);
      box.m.textContent = pad(Math.floor(left / 60000) % 60);
      box.s.textContent = pad(Math.floor(left / 1000) % 60);
    };
    tick();
    if (drop - Date.now() > 0) timer = setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harbor-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAtelier = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    root.dataset.motionReady = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = root.querySelectorAll('.atelier-intro > *, .atelier-duo__card, .atelier-market header, .atelier-products article, .atelier-origin > *, .atelier-chronicle > header, .atelier-chronicle__image, .atelier-chronicle__chapters article, .atelier-serve > *, .atelier-closing > *');
    targets.forEach((item) => {
      item.classList.add('atelier-reveal');
      if (item.matches('.atelier-duo__card, .atelier-chronicle__image, .atelier-closing__image')) item.classList.add('atelier-reveal--image');
    });
    root.classList.add('is-motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((item) => observer.observe(item));
  };
  document.querySelectorAll('.atelier').forEach(initAtelier);
  document.addEventListener('shopify:section:load', (event) => initAtelier(event.target.querySelector('.atelier')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
